export interface PwRule {
  id: string;
  label: string;
  test: (pw: string) => boolean;
}

export const PW_RULES: PwRule[] = [
  { id: "len", label: "At least 8 characters", test: (p) => p.length >= 8 },
  { id: "upper", label: "An uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { id: "lower", label: "A lowercase letter", test: (p) => /[a-z]/.test(p) },
  { id: "num", label: "A number", test: (p) => /\d/.test(p) },
  { id: "special", label: "A symbol (!@#$…)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

/** Hard requirement enforced by the backend (min length). */
export const MIN_LENGTH = 8;

const STRENGTH = [
  { label: "Too weak", color: "#e11d48" },
  { label: "Weak", color: "#f97316" },
  { label: "Fair", color: "#eab308" },
  { label: "Good", color: "#22c55e" },
  { label: "Strong", color: "#16a34a" },
  { label: "Very strong", color: "#059669" },
];

export function passwordStrength(pw: string) {
  const met = PW_RULES.filter((r) => r.test(pw)).length;
  const bonus = pw.length >= 12 ? 1 : 0;
  const score = Math.min(5, pw ? met + bonus : 0);
  return { score, ...STRENGTH[score] };
}
